var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"value":_vm.Data,"clearable":"","align":_vm.config.Align,"type":"datetime","placeholder":'选择'+(_vm.config.Title||'日期'),"value-format":"yyyy-MM-dd HH:mm:ss","size":_vm.size ||_vm.config.Size,"disabled":_vm.disabled ||_vm.config.Disabled},on:{"input":_vm.OnInput}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }